(() => {
  const initialize = () => {
    document.querySelectorAll('[data-lm-buybar]').forEach(bar => {
      if (bar.dataset.initialized) return;
      const id = bar.dataset.sectionId;
      const source = document.getElementById(`AddToCart-${id}`);
      const sourcePrice = document.getElementById(`ProductPrice-${id}`);
      const button = bar.querySelector('[data-lm-add]');
      const price = bar.querySelector('[data-lm-price]');
      if (!source || !sourcePrice) return;
      bar.dataset.initialized = 'true';
      const sync = () => {
        button.disabled = source.disabled;
        button.textContent = source.disabled ? source.textContent.trim() : bar.dataset.actionLabel;
        price.textContent = sourcePrice.textContent;
      };
      const visibility = () => {
        const pastForm = source.getBoundingClientRect().bottom < 0;
        bar.hidden = !pastForm || document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open');
      };
      new MutationObserver(sync).observe(source, {attributes: true, childList: true, subtree: true});
      new MutationObserver(sync).observe(sourcePrice, {childList: true, subtree: true});
      new MutationObserver(visibility).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
      new MutationObserver(visibility).observe(document.body, {attributes: true, attributeFilter: ['class']});
      window.addEventListener('scroll', visibility, {passive: true});
      button.addEventListener('click', () => {
        if (source.disabled) return;
        source.closest('form').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        source.focus({preventScroll: true});
      });
      sync();
      visibility();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
